// extracted by mini-css-extract-plugin
export default {"wrap":"Center_wrap__J1dPS","inner":"Center_inner__ko38f"};